import { useGetUserPermissionsAgreementsByIdQuery, PermissionKey } from '@client/api';

interface UseAgreementPermissionsProps {
  id?: string;
}

export function useAgreementPermissions({ id }: UseAgreementPermissionsProps) {
  const { data, error, isError, isLoading } = useGetUserPermissionsAgreementsByIdQuery(
    {
      id: id ?? '',
    },
    { skip: !id },
  );
  return {
    data,
    error,
    isError,
    isLoading,
    hasPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.every((permission) => data.permissions.includes(permission));
    },
    hasAnyPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.some((permission) => data.permissions.includes(permission));
    },
  };
}
